// extracted by mini-css-extract-plugin
export default {"pointHistories":"B9Z4vDoBUkrTbK6u67rn","spacer":"lGEXQOjrWsFqevdpZJKx","loading":"kmfKikHwScBDJ_g6S8uu"};